import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBybitSaving = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m19.982 2 .048.465a2.697 2.697 0 0 0 2.34 2.394 2.87 2.87 0 0 0-2.329 2.539l-.06.602-.054-.607a2.839 2.839 0 0 0-2.304-2.534 2.665 2.665 0 0 0 2.313-2.39L19.982 2ZM14.29 4.5a.5.5 0 0 1 .483.368l1.09 4a.5.5 0 0 1-.481.632H8.619a.5.5 0 0 1-.483-.632l1.091-4A.5.5 0 0 1 9.71 4.5h4.582ZM9.71 3a2 2 0 0 0-1.93 1.474l-1.091 4A2 2 0 0 0 8.619 11h6.763a2 2 0 0 0 1.93-2.526l-1.092-4A2 2 0 0 0 14.29 3H9.71Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M3.71 13.5a.5.5 0 0 0-.483.368l-1.09 4a.5.5 0 0 0 .482.632h6.763a.5.5 0 0 0 .482-.632l-1.091-4a.5.5 0 0 0-.482-.368H3.709Zm-1.93-.026A2 2 0 0 1 3.71 12h4.58a2 2 0 0 1 1.93 1.474l1.091 4A2 2 0 0 1 9.381 20H2.62a2 2 0 0 1-1.93-2.526l1.09-4Zm13.93.026a.5.5 0 0 0-.483.368l-1.09 4a.5.5 0 0 0 .482.632h6.763a.5.5 0 0 0 .482-.632l-1.091-4a.5.5 0 0 0-.482-.368h-4.582Zm-1.93-.026A2 2 0 0 1 15.71 12h4.58a2 2 0 0 1 1.93 1.474l1.091 4A2 2 0 0 1 21.381 20H14.62a2 2 0 0 1-1.93-2.526l1.09-4Z"
    />
  </svg>
);
export default SvgTwoColorBybitSaving;
